document.addEventListener('DOMContentLoaded', function () {
    const dropdowns = document.querySelectorAll('[data-lang-dropdown]');

    function closeDropdown(dropdown) {
        const trigger = dropdown.querySelector('.wpml-ls-current-language > .wpml-ls-link');

        dropdown.classList.remove('__open');

        if (trigger) {
            trigger.setAttribute('aria-expanded', 'false');
        }
    }

    function openDropdown(dropdown) {
        const trigger = dropdown.querySelector('.wpml-ls-current-language > .wpml-ls-link');

        dropdown.classList.add('__open');

        if (trigger) {
            trigger.setAttribute('aria-expanded', 'true');
        }
    }

    dropdowns.forEach(function (dropdown) {
        const navigation = dropdown.querySelector('[role="navigation"], nav');
        const trigger = dropdown.querySelector('.wpml-ls-current-language > .wpml-ls-link');

        if (!navigation || !trigger) {
            return;
        }

        navigation.setAttribute('aria-label', dropdown.dataset.langDropdownLabel);
        trigger.dataset.langSwitcherLabel = dropdown.dataset.langSwitcherLabel;
        trigger.setAttribute('aria-haspopup', 'true');
        trigger.setAttribute('aria-expanded', 'false');

        trigger.addEventListener('click', function (event) {
            event.preventDefault();

            if (dropdown.classList.contains('__open')) {
                closeDropdown(dropdown);
                return;
            }

            dropdowns.forEach(function (otherDropdown) {
                if (otherDropdown !== dropdown) {
                    closeDropdown(otherDropdown);
                }
            });

            openDropdown(dropdown);
        });
    });

    document.addEventListener('click', function (event) {
        dropdowns.forEach(function (dropdown) {
            if (!dropdown.contains(event.target)) {
                closeDropdown(dropdown);
            }
        });
    });

    document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') {
            return;
        }

        dropdowns.forEach(function (dropdown) {
            if (dropdown.classList.contains('__open')) {
                closeDropdown(dropdown);
            }
        });
    });
});
